import {Component, OnInit, OnDestroy, TemplateRef, ViewChild} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from '../../custom-services/ApiService';
import {environment} from '../../../environments/environment';
import {CommaSeparatorService} from '../../service/comma-separator.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CommonUtilService} from '../../service/utils/common-utils';
import {MultiApiService} from '../../custom-services/multi-api.service';
import {SECTION_CONSTANTS} from "../../constants/global-constant";
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-aacknowledgement-slip',
    templateUrl: './aacknowledgement-slip.component.html',
    styleUrls: ['./aacknowledgement-slip.component.css'],
    standalone: false
})
export class AacknowledgementSlipComponent implements OnInit, OnDestroy {
  userTin!: any;
  returnResponse!: any;
  tinDigits: any[] = [];
  tinDigitsBangla: any[] = [];
  totalAmount: string;
  totalTaxAmount: string;
  returnRegNo: string;
  returnSubmissionDate: string;
  isShow: boolean = false;
  modalRef: BsModalRef;
  isAmendedReturn: boolean;
  sectionNumber: string;
  taxpayerQRData: string = null;
  printTitle: string = null;
  currentLang: string = 'en';
  isNormal: boolean;
  isRegular: boolean;
  section: any;
  isPublicUrl: boolean;
  ackUniqueKey: string;
  isApiLoading: boolean = false;
  pathBaseUrl: string = environment.production ? 'https://etaxnbr.gov.bd/#/' : 'https://staging.etaxnbr.gov.bd/#/';
  isMobile: boolean = false;
  constructor(private toastr: ToastrService, private apiService: ApiService, private commaseparator: CommaSeparatorService, private modalService: BsModalService, private multiApiService: MultiApiService, private route: ActivatedRoute) {
  }

  private readonly ACKNOWLEDGEMENT_PUBLIC_URL = 'ack-rec';

  ngOnInit(): void {
    this.isMobile = window.innerWidth < 768;
    this.isPublicUrl = this.route.snapshot.url[0].path === this.ACKNOWLEDGEMENT_PUBLIC_URL;
    this.ackUniqueKey = this.route.snapshot.queryParams['key'];
    this.userTin = localStorage.getItem('tin');
    if (this.isPublicUrl) {
      this.getPublicSlipData();
    } else {
      this.checkSubmissionStatus();
    }
  }

  convertToBanglaDigits(array) {
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return array.map((digit) => {
      if (typeof digit === 'number' && digit >= 0 && digit <= 9) {
        return banglaDigits[digit];
      } else {
        return digit;
      }
    });
  }

  checkSubmissionStatus() {
    this.multiApiService.getSubmissionIncludingDacon()
      .subscribe(res => {
        if (res.replyMessage === 'NONE') {
          this.isShow = false;
          this.toastr.error('Please submit your return in online first!', '', {
            timeOut: 3000
          });
        } else if (res.replyMessage === 'ONLINE') {
          this.getSlipData('', true);
        } else if (res.replyMessage === 'ONLINE_PENDING') {
          ;
          this.isShow = false;
          this.toastr.error('Your return is in draft mode. Submit your return first.', '', {
            timeOut: 3000
          });
        } else {
          ;
          this.isShow = false;
          this.toastr.error('Acknowledgement Slip is not available for Offline Submission!', '', {
            timeOut: 3000
          });
        }
      }, error => {
        ;
        this.isShow = false;
      });
  }

  getPublicSlipData(): void {
    this.isApiLoading = true;
    this.apiService.get(environment.taxpayer_base_url + '/filingservice/v3/api/certificate/taxpayer/certificate-by-unique-key/get' + '?uniqueKey=' + this.ackUniqueKey)
      .subscribe(res => {
        this.isApiLoading = false;
        if (res?.success && !res.replyMessage?.certificate) {
          this.returnResponse = res.replyMessage;
          this.isShow = true;
          this.tinDigits = Array.from(this.returnResponse?.tin, Number);
          this.tinDigitsBangla = this.convertToBanglaDigits(this.tinDigits);
          this.returnSubmissionDate = this.formatDate(this.returnResponse?.submissionDate);
          this.totalAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.totalIncome));
          this.totalTaxAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.taxPaid));
          this.taxpayerQRData = this.pathBaseUrl + this.ACKNOWLEDGEMENT_PUBLIC_URL + '?key=' + this.ackUniqueKey;
          this.printTitle = 'Acknowledgement-' + this.returnResponse?.tin;
          this.section = Object.values(SECTION_CONSTANTS)
            .find(item => item.value === this.returnResponse?.section);
          ;
        } else {
          ;
          this.isShow = false;
          this.toastr.error(res['error'].errorMessage, 'Error', {
            timeOut: 3000
          });
        }
      }, error => {
        ;
        this.isApiLoading = false;
        this.isShow = false;
      });
  }

  getSlipData(params, isOnline = false): void {
    let endPoint: string = '';
    if (isOnline) {
      endPoint = environment.taxpayer_base_url + '/filingservice/v3/api/certificate/taxpayer/tax-cert-and-ack-receipt-online/get?reportType=ACKNOWLEDGEMENT_SLIP' + params;
    } else {
      endPoint = environment.taxpayer_base_url + '/filingservice/v3/api/certificate/taxpayer/ack-receipt' + params;
    }
    this.apiService.get(endPoint)
      .subscribe(res => {
        if (res?.success) {
          this.returnResponse = res.replyMessage;
          this.isShow = true;
          this.tinDigits = Array.from(this.returnResponse?.tin, Number);
          this.tinDigitsBangla = this.convertToBanglaDigits(this.tinDigits);
          this.returnSubmissionDate = this.formatDate(this.returnResponse?.submissionDate);
          this.totalAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.totalIncome));
          this.totalTaxAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.taxPaid));
          // this.taxpayerQRData = environment.taxpayer_base_url + `/filingservice/v3/api/verify-psr?tin=${this.returnResponse?.tin}&ay=${this.returnResponse?.assessmentYear}`;
          this.taxpayerQRData = isOnline ? this.pathBaseUrl + this.ACKNOWLEDGEMENT_PUBLIC_URL + '?key=' + this.returnResponse?.ackUniqueKey :
          this.pathBaseUrl + 'submission-verification';
          this.printTitle = 'Acknowledgement-' + this.returnResponse?.tin;
          this.section = Object.values(SECTION_CONSTANTS)
            .find(item => item.value === this.returnResponse?.section);
          ;
        } else {
          ;
          this.isShow = false;
          this.toastr.error(res['error'].errorMessage, 'Error', {
            timeOut: 3000
          });
        }
      }, error => {
        ;
        this.isShow = false;
      });
  }

  setLanguage(lang: string): void {
    this.currentLang = lang;
  }

  ngOnDestroy(): void {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  private formatDate(dateValue: string | Date): string {
    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
